import React, { useEffect, useState } from 'react'
import { Box, Typography } from '@mui/material'
import AdxFormModal from 'components/reusable/modal/AdxFormModal'
import ACExternalEvalDataChip from './ACExternalEvalDataChip'
import ACExternalEvalDataTable from './ACExternalEvalDataTable'
import ViewListIcon from '@mui/icons-material/ViewList'
import AdxButton from 'components/custom/AdxButton'

const ACExternalEvalTable = ({
  getExternalData,
  externalCSVUpload,
  setExternalCSVUpload,
  setCompleteUploadExternal,
  setGetExternalData,
  externalLoading,
}) => {
  const staffData = getExternalData.staff
  const validateData = getExternalData?.staff_count - getExternalData?.errors_count

  const handleReuploadCSV = () => {
    setExternalCSVUpload(false)
    setCompleteUploadExternal(false)
    setGetExternalData([])
  }

  const handleConfirm = () => {
    setExternalCSVUpload(false)
  }

  const CustomHeader = () => {
    return (
      <>
        <Box
          sx={{
            py: 1,
            px: 4,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: 1,
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <ViewListIcon sx={{ color: 'alternate.main', mr: 1, fontSize: 28 }} />
            <Typography variant="h4">External Evaluation Results</Typography>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '10%' }}></Box>
        </Box>
      </>
    )
  }

  return (
    <AdxFormModal
      open={externalCSVUpload}
      disableEscapeKeyDown
      disableAutoFocus={true}
      sx={{
        '&.MuiModal-root': { overflowY: 'auto' },
        paddingY: '20px',
      }}
      sxModal={{
        minWidth: { xs: 'none', sm: 'calc(100vw - 30px)', lg: '1000px' },
        width: { xs: 'calc(100vw - 30px)', lg: 'calc(100vw - 1500px)' },
      }}
      customHeader={<CustomHeader />}
    >
      <>
        <Box
          sx={{
            width: '100%',
            minHeight: '300px',

            display: 'flex',
            flexDirection: 'column',
            rowGap: 2,
          }}
        >
          <Box
            sx={{
              width: 1,

              display: 'flex',
              alignItems: { xs: 'flex-start', sm: 'center' },
              flexDirection: { xs: 'column', sm: 'row' },
              justifyContent: 'space-between',
            }}
          >
            <Typography mr={1} variant="body2" color="light-gray-text.main">
              Check the details uploaded and click Confirm.
            </Typography>
            <Box
              sx={{
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                justifyContent: 'flex-start',
                rowGap: 0.5,
              }}
            >
              <ACExternalEvalDataChip
                sx={{ mr: 2 }}
                color="info.main"
                content={`${getExternalData?.staff_count} data found`}
              />
              <ACExternalEvalDataChip
                color="error.main"
                content={`${getExternalData.errors_count} ${
                  getExternalData?.errors_count > 1 ? 'errors' : 'error'
                } found`}
              />
            </Box>
          </Box>
          <Box>
            <Box
              sx={{
                width: '100%',
                height: '45px',
                backgroundColor: 'gray-background.main',
                display: 'flex',
                py: 1,
                px: 3,
                alignItems: 'center',
                overflow: 'auto',
              }}
            >
              <Box width={1 / 3}>
                <Typography align="center" variant="body1" color="dark-gray-text.main">
                  Reviewee Name
                </Typography>
              </Box>
              <Box width={1 / 3}>
                <Typography align="center" variant="body1" color="dark-gray-text.main">
                  Reviewee Email
                </Typography>
              </Box>
              <Box width={1 / 3}>
                <Typography align="center" variant="body1" color="dark-gray-text.main">
                  Score
                </Typography>
              </Box>
            </Box>
            <Box>
              <ACExternalEvalDataTable staffData={staffData} externalLoading={externalLoading} />
            </Box>
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              flexDirection: 'row',
              alignItems: 'center',

              width: '100%',
              height: '50px',
              columnGap: 1,
            }}
          >
            <AdxButton
              variant={'outlined'}
              onClick={handleReuploadCSV}
              sx={{ width: { xs: 1 / 2, sm: 1 / 4 } }}
            >
              Cancel
            </AdxButton>
            <AdxButton
              variant={'contained'}
              onClick={handleConfirm}
              sx={{ width: { xs: 1 / 2, sm: 2 / 5 } }}
              disabled={
                staffData && validateData === getExternalData?.staff_count && !externalLoading
                  ? false
                  : true
              }
            >
              Confirm
            </AdxButton>
          </Box>
        </Box>
      </>
    </AdxFormModal>
  )
}

export default ACExternalEvalTable
